import React from 'react';
import { TriangleAlertIcon } from 'lucide-react';
export const BLANK_BRANCH_RISK = 'On main, a blank or other branch (e.g. Remote) gives 0 base BPS.';

/** Small amber "Risk" note for known production behaviour that may surprise. */
export function RiskNote({
  children = BLANK_BRANCH_RISK
}: {
  children?: React.ReactNode;
}) {
  return <p className="flex items-start gap-1.5 rounded border border-[#F9C88C] bg-sf-amber-light px-2 py-1.5 text-xs text-sf-text" data-id="element-858" data-mp="1jawheyt66ub8">
      <TriangleAlertIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-sf-amber-text" aria-hidden="true" data-id="element-859" data-mp="1oar8b2cy3jwa" />
      <span data-id="element-860" data-mp="1x933ziso57vl">
        <strong className="text-sf-amber-text" data-id="element-861" data-mp="1x8kzxzzrlpd4">Risk:</strong> {children}
      </span>
    </p>;
}